import { render, staticRenderFns } from "./OrderFoodRecord.vue?vue&type=template&id=dd1ef432&scoped=true"
import script from "./OrderFoodRecord.vue?vue&type=script&lang=js"
export * from "./OrderFoodRecord.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodRecord.vue?vue&type=style&index=0&id=dd1ef432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1ef432",
  null
  
)

export default component.exports